
import { defineComponent } from "vue";
import { ILot } from "@/interfaces/tender";
import { PropType } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "LotItem",
  props: {
    lot: {
      type: Object as PropType<ILot>,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['getLanguage']),
    categoryTitle() {
      switch (this.getLanguage) {
        case 'uz':
          return `${this.lot.category_code} ${this.lot.category_title_uz}`;
        case 'ru':
          return `${this.lot.category_code} ${this.lot.category_title_ru}`;
        case 'en':
          return `${this.lot.category_code} ${this.lot.category_title_en}`;
        default:
          return '';
      }
    },
  },
  methods: {
    headerText(text: string) {
      if (window.innerWidth < 768) {
        return `${text}:`
      } else {
        return text
      }
    }
  }
});
